module.exports = __webpack_public_path__ + "static/img/61.1693b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/61.png
// module id = 60VO
// module chunks = 0